module.exports = __webpack_public_path__ + "img/card5.a048afb0.jpg";